import { createAction, props } from '@ngrx/store';
import { PaymentType } from './payment-type.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch record payment type'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch record payment type success', 
    props<{ listData: PaymentType[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch record payment type failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record payment type',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record payment type success', 
    props<{ singleData: PaymentType }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record payment type failure', 
    props<{ error: string }>()
);


// Add Data
export const addRecord = createAction(
    '[Data] Add record payment type',
    props<{ newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record payment type success'
);
export const addRecordFailure = createAction(
    '[Data] Add record payment type failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record payment type',
    props<{ id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record payment type success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record payment type failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record payment type',
    props<{ id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record payment type success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record payment type failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state payment type',
);